/**
 * İşletmenin yazdığı CSS'i bir gölge köke ekler (§10.2 "özel CSS"; Pro ve üstü).
 *
 * **Gölge kök bu özelliği güvenli kılan şey.** Buraya konan CSS ana sayfanın tek bir pikseline
 * bile dokunamıyor; aynı metni sayfaya enjekte etseydik, bir yöneticiye ziyaretçinin gördüğü
 * sayfayı değiştirme yetkisi vermiş olurduk.
 *
 * **EN SONA ekleniyor ve her çağrıda yeniden sona taşınıyor.** Widget'ın stili iki aşamada
 * geliyor: balon yüklenirken bir stil, sohbet penceresi tembel yüklenince ikincisi. İkisi de
 * aynı köke yazıyor ve CSS'te sonra gelen kural kazanıyor — bu yüzden işletmenin metni her iki
 * aşamadan sonra da sona alınıyor. İlk eklendiği yerde bıraksaydık, sohbet penceresi açılınca
 * ürünün stili işletmenin kuralını ezerdi ve işletme `!important` yazmak zorunda kalırdı.
 *
 * **İkinci bir etiket açılmıyor:** var olan düğüm `append` ile taşınıyor. İki kopya, aynı
 * kuralı iki kez indirmek ve bir gün birinin güncellenip ötekinin kalması demekti.
 *
 * **Doğrulama SUNUCUDA** (`checkBrand`): uzak istek attıran kalıplar (`@import`, `url(`) orada
 * reddediliyor. Burada ikinci bir süzgeç yazmak, aynı kuralı iki yere koymak ve bir gün
 * ikisinin ayrışması olurdu.
 *
 * **Açılır pencereler (engage) KAPSAM DIŞI:** onların kendi gölge kökü ve kendi stili var,
 * marka kaydını hiç okumuyorlar. Oraya da uygulamak ayrı bir iş; bugün vadedilen şey widget.
 */
export function applyCustomCss(root: ShadowRoot, css: string | undefined): void {
  if (css === undefined || css.trim() === '') return;

  const existing = root.querySelector('style[data-destera-custom]');
  const style = existing ?? document.createElement('style');
  style.textContent = css;
  style.setAttribute('data-destera-custom', '');
  /** Zaten bağlıysa `append` onu SONA TAŞIYOR; ikinci bir düğüm açmıyor. */
  root.append(style);
}
